module.exports = __webpack_public_path__ + "static/media/aws_logo.c447da21.png";